import { Box } from '@mui/joy';

const size = 26;

export function JunbeeLogo() {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: `${(size / 26) * 9}px`,
        backgroundColor: 'primary.500',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          width: `${(size / 26) * 13}px`,
          height: `${(size / 26) * 14}px`,
          backgroundColor: '#fff',
          clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
        }}
      />
    </Box>
  );
}
